var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundSaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1899,
    height: 787,
    viewBox: "0 0 1899 787",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1898.86V489.551L0 786.248V0Z",
    fill: "url(#paint0_linear_17423_328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17423_328",
    x1: 1609.58,
    y1: 44.5047,
    x2: 164.667,
    y2: 637.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43377C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8071CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSaq);
export default __webpack_public_path__ + "static/media/backgroundSaq.83e7070b03517a73b885236ad9e5557e.svg";
export { ForwardRef as ReactComponent };